import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export interface FooterProps {
  /** ブランド共通グラデーションを使用（LP等） */
  useBrandGradient?: boolean;
}

export function Footer({ useBrandGradient = false }: FooterProps) {
  const theme = useTheme();

  const gradient = useBrandGradient
    ? theme.runport?.gradient
    : theme.custom?.gradient || theme.runport?.gradient || theme.palette.primary.main;

  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        textAlign: 'center',
        background: gradient,
      }}
    >
      <Typography variant="body2" sx={{ color: '#fff' }}>
        © 2026{' '}
        <Box
          component="a"
          href="https://swandive.co.jp"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            color: '#fff',
            textDecoration: 'none',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          株式会社Swandive
        </Box>
      </Typography>
    </Box>
  );
}
